<!--    We don't surround the router-outlet nor the app-footer with a container-fluid.
        That's the job of the component to define its width. This gives them the ability to be at 100%.-->
<router-outlet></router-outlet>

<app-footer></app-footer>